angular.module('dealerware.web.filters').filter('percentage', ['$filter', function($filter) {
    return function (input, decimals) {
        if (isNaN(input)) { input = 0; }
        return $filter('number')(input * 100, decimals) + '%';
    };
}]);
